var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#af0800",
    d: "M4 1h1M4 2h2M4 3h1m1 0h1M3 4h1m3 0h1M2 5h1m5 0h1M1 6h1m7 0h1M1 7h1m7 0h1M1 8h1m7 0h1M1 9h1m2 0h2m2 0h1m-7 1h2m2 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f21c00",
    d: "M5 3h1M4 4h1m1 0h1M3 5h1m3 0h1M2 6h1m5 0h1M2 7h1m5 0h1M2 8h1m5 0h1M2 9h2m2 0h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4c00",
    d: "M5 4h1M4 5h1m1 0h1M3 6h1m3 0h1M3 7h1m3 0h1M3 8h3m1 0h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8300",
    d: "M5 5h1M4 6h3M4 7h1m1 0h1M6 8h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffae00",
    d: "M5 7h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire5A);
export default __webpack_public_path__ + "static/media/fire5a.c599b3637e1c39e061f1777118d83a58.svg";
export { ForwardRef as ReactComponent };